import React, { useState } from "react";
import Webcam from "react-webcam";
import Loader from "../../../../utils/loader";
import captureIcon from "../../../../utils/captureIcon.svg";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useTranslation } from "react-i18next";

type CaptureSelfieProps = {
    setUserSelfie: (imageSrc: string) => void;
    isPending: boolean;
    mutate: (data: { userPhoto: string }) => void;
    handleRetry: () => void;
    backBtnConfig: object;
};

const CaptureSelfie: React.FC<CaptureSelfieProps> = ({ setUserSelfie, isPending, mutate, handleRetry, backBtnConfig }) => {
    const [camerPermissionStatus, setCameraPermissionStatus] = useState<boolean>(true);
    const { t } = useTranslation()
    const handleMediaError = (error: { message: string }) => {
        if (error.message.includes("Permission denied")) {
            setCameraPermissionStatus(false);
        }
    }


    return (
        <div className="tngnt-flex tngnt-flex-col tngnt-items-center tngnt-gap-4 sm:tngnt-gap-6 tngnt-pt-12 sm:tngnt-pt-16 tngnt-justify-center tngnt-w-[100%]">
            <button className="tangent_backbtn_custom tangent_backbtn_mob_custom tngnt-absolute tngnt-top-0 tngnt-self-start tngnt-m-4 tngnt-text-[30px]" onClick={handleRetry}>
                {backBtnConfig ? <img src={backBtnConfig.backBtn_icon} alt="back button" /> : <IoIosArrowRoundBack color="#929292" size={"3rem"} />}
            </button>
            {
                camerPermissionStatus ?
                    <div className="tangent_camera_screen_custom tangent_camera_screen_mob_custom tngnt-relative tngnt-flex tngnt-flex-col tngnt-items-center tngnt-p-2 sm:tngnt-w-[80%] tngnt-w-[100%]">
                        <Webcam
                            className="tngnt-w-[100%]"
                            audio={false}
                            screenshotFormat="image/jpeg"
                            mirrored
                            videoConstraints={{
                                facingMode: "user",
                                aspectRatio: 1.6
                            }}
                            onUserMediaError={handleMediaError}
                        >
                            {({ getScreenshot }) => (
                                <button
                                    className="tngnt-absolute tngnt-bottom-1"
                                    onClick={() => {
                                        let imageSrc = getScreenshot()
                                        setUserSelfie(imageSrc)
                                        mutate({ userPhoto: imageSrc })
                                    }}
                                >
                                    <img src={captureIcon} alt="Capture Icon" className="tngnt-w-[90%] sm:tngnt-w-[70%]" />
                                </button>
                            )}
                        </Webcam>
                    </div> : <div className="tngnt-min-h-[300px] tngnt-content-center tngnt-w-[80%] sm:tngnt-w-[60%]">
                        <p className="tangent_global_style tangent_global_style_custom tangent_camera_permission_warning_custom tngnt-text-[14px] tngnt-text-center tngnt-leading-[20px] tngnt-border-2 tngnt-rounded tngnt-p-[20px] tngnt-flex tngnt-flex-col sm:tngnt-flex-row tngnt-items-center tngnt-gap-[6px]">{t('cameraPermissionWarning')}</p>
                    </div>}
            {isPending && <Loader />}
        </div >
    )
}

export default CaptureSelfie